export default __webpack_public_path__ + "static/media/epl-banner.0f3d6470.webp";